module.exports = __webpack_public_path__ + "static/images/containers/CommandCenterCard/images/ribbon-mask.4982da8a.png";


//////////////////
// WEBPACK FOOTER
// ./containers/CommandCenterCard/images/ribbon-mask.png
// module id = 3084
// module chunks = 11